import React from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";

import { isValidPatientId } from "utils/isValidPatientId";
import { pathGenerators } from "utils/routes";

import { NavigationBar } from "../pages/patient/components/NavigationBar/NavigationBar";

/**
 * Layout for patient-specific pages — renders the NavigationBar (tabs) above the
 * nested route content. The patient id is the /patients/:patientId/... path param
 * (the single source of truth); if it is missing we send the user to the patient
 * list rather than render patient pages without a patient.
 */
const PatientLayout = () => {
  const { patientId } = useParams();

  // Guard against a missing OR malformed id ("undefined"/"null" strings, or an
  // un-interpolated ":patientId" route template) — otherwise the child pages
  // fire GET /patient/get/<bad> calls that 500. Send the user to the patient list.
  if (!isValidPatientId(patientId)) {
    return <Navigate to={pathGenerators.global.patient()} replace />;
  }

  return (
    <>
      <NavigationBar />
      <Outlet />
    </>
  );
};

export { PatientLayout };
